import React from 'react'
import styled from '@emotion/styled'
import { Input, Space } from 'antd'
import { PortalArticleImage } from '../../../../models/PortalArtigoModel'
import { PortalEditorField } from '../PortalEditorField'
import { PortalImagePathField } from '../PortalImagePathField'
import { RichTextField } from '../PortalRichTextFields'

interface ImageBlockEditorProps {
  value: PortalArticleImage
  anchorId?: string
  onChange: (image: PortalArticleImage, anchorId?: string) => void
}

export function ImageBlockEditor({ value, anchorId, onChange }: ImageBlockEditorProps) {
  const image = value || { src: '', alt: '', width: 1200, height: 675 }

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <PortalImagePathField
        value={{
          url: image.src,
          alt: image.alt,
          width: image.width,
          height: image.height,
        }}
        onChange={(nextImage) =>
          onChange(
            {
              ...image,
              src: nextImage.url || '',
              alt: nextImage.alt || '',
              width: Number(nextImage.width || 0),
              height: Number(nextImage.height || 0),
            },
            anchorId
          )
        }
      />
      <AdvancedFields>
        <summary>Configurações avançadas</summary>
        <PortalEditorField label="ID da âncora da imagem">
          <Input
            value={anchorId}
            placeholder="ID da âncora"
            onChange={(event) => onChange(image, event.target.value)}
          />
        </PortalEditorField>
      </AdvancedFields>
      <PortalEditorField label="Link da imagem (opcional)">
        <Input
          value={image.href}
          placeholder="https://exemplo.com.br ou /pagina"
          onChange={(event) => onChange({ ...image, href: event.target.value }, anchorId)}
        />
      </PortalEditorField>
      <RichTextField
        label="Legenda"
        value={image.caption}
        onChange={(caption) => onChange({ ...image, caption }, anchorId)}
      />
    </Space>
  )
}

const AdvancedFields = styled.details`
  width: 100%;
  color: #595959;

  summary {
    cursor: pointer;
    color: #595959;
    font-weight: 600;
    margin-bottom: 8px;
  }
`
